<footer class="w3-container w3-blue w3-center w3-margin-top">
  <p class="w3-small">
    Copyright &copy; szymczak.dev. All Rights Reserved.
  </p>
</footer>
